import { __ } from '@wordpress/i18n'

export default {
  message: __('React is working in plugin :)', 'dhsv_theme'),
}
